/* eslint-disable */
import React from 'react';
import { Shield, Users, Globe } from 'lucide-react';

const Overview = () => {
  const highlights = [
    {
      icon: <Shield className="highlight-icon" />,
      title: "Health Security",
      description: "Protecting communities from public health threats"
    },
    {
      icon: <Users className="highlight-icon" />,
      title: "Multisectoral Collaboration",
      description: "Working across human, animal and environmental health"
    },
    {
      icon: <Globe className="highlight-icon" />,
      title: "One Health Approach",
      description: "Integrated solutions for complex health challenges"
    }
  ];

  return (
    <section className="overview-section" id='overview'>
      <div className="section-header">
        <div className="section-badge">Who We Are</div>
        <h2>Department Overview</h2>
        <p className="section-description">
          Leading South Sudan's efforts in health security and emergency preparedness
        </p>
      </div>
      
      <div className="content-grid">
        <div className="main-content">
          <div className="text-content">
            <p className="intro-text">
              The <strong>Department of Health Security, Surge Capacity Development, and One Health</strong> 
              at the Ministry of Health, Republic of South Sudan, is dedicated to strengthening the 
              nation's resilience against public health threats through coordinated, multisectoral approaches.
            </p>
            
            <div className="mission-vision-grid">
              <div className="mission-card">
                <h4>Our Mission</h4>
                <p>To strengthen South Sudan's health security by enhancing preparedness, building surge capacity, and promoting integrated One Health approaches.</p>
              </div>
              <div className="vision-card">
                <h4>Our Vision</h4>
                <p>A resilient and safe South Sudan where communities are protected from health threats through proactive, multisectoral collaboration.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="highlights-sidebar">
          <div className="highlights-container">
            <h3>Our Focus Areas</h3>
            {highlights.map((highlight, index) => (
              <div key={index} className="highlight-item">
                <div className="highlight-icon-container">
                  {highlight.icon}
                </div>
                <div className="highlight-content">
                  <h4>{highlight.title}</h4>
                  <p>{highlight.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="one-health-banner">
        <div className="banner-content">
          <h3>South Sudan One Health Secretariat</h3>
          <p>
            Hosted by our department, the Secretariat serves as the central coordinating body for 
            enhancing national preparedness, guiding policy development, fostering research, and 
            building collaborative networks across government agencies, development partners, and communities.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Overview;